import { Container } from 'react-bootstrap'

import NavbarPages from '../NavbarPages'
import HeaderPages from '../HeaderPages'
import KiveUso from '../../../Resourses/products/kive-uso-comercial-racionadores.svg'

const imgHeader = "./images/productos/header-productos-kive-racionador-mango.jpg";
const imgThumbIzq = "./images/productos/productos_thumbs--racionadores-empaque-kive.jpg";
const altText = "CINTA DE EMPAQUE";

const tipoColor = 'productos__detail--tipoPapelRami'

const detailLine1 = "RACIONADORES";
// const detailLine2 = "ADHESIVA";
const detailLine3 = "DE EMPAQUE";

const imgTable ="./images/productos/kive/cuadro-kive-racionador-de-empaque.jpg";

const textoDetail1 = 'Ideal para trabajos intensivos y en tareas de depósitos, son utilizados para acelerar el cerrado de cajas y dejando un corte prolijo.'
const textoDetail2 = 'Son livianos y ágiles en el uso diario. Solo basta con apoyar el racionador sobre la caja para que la cinta se adhiera y deslizarlo hasta cerrar la caja; el dentado metálico del racionador cortará la cinta, dejando el racionador preparado para la próxima caja.'
const textoDetail3 = 'Vienen CON y SIN Mango.'

const imgThumb1 = './images/productos/kive-racionadores-empaque/kive-racionadores-empaque-3.jpg';
const imgThumb1Alt = 'Empaque 5103.';

const imgThumb2 = './images/productos/kive-racionadores-empaque/kive-racionadores-empaque-2.jpg';
const imgThumb2Alt = 'Empaque 5102.';

const imgThumb3 = './images/productos/kive-racionadores-empaque/kive-racionadores-empaque-1.jpg';
const imgThumb3Alt = 'Empaque 5101.';

const RacionadoresEmpaqueKive = () => {
  return (
    <Container className='mb-0'>
        <NavbarPages className="p-0" />
        <div className='row'>
          <div className='col-12 mb-4'>
            <HeaderPages img={imgHeader} alt={"Productos Kive Cintas"} />
          </div>
          <div className='col-12 col-sm-6 col-md-5 productos__imgContainer'>
            <img 
              src={imgThumbIzq} 
              alt={altText} 
              className='d-block w-100 productos__imgContainer--img' 
              loading='lazy'/>
          </div>
          <div className='col-12 col-sm-12 col-md-7 productos__vert--int mb-4 mt-1'>
            <div className='row productos__detail'>
              <div className='col-12'>
                <p className={`productos__detail--tipo ${tipoColor}`}>{detailLine1}
                 {/* <span className={`productos__detail--caracteristica ${tipoColor}`}> {detailLine2}</span> */}
                </p>
                <p className={`productos__detail--caracteristica ${tipoColor}`}>{detailLine3}</p>
                <img src={KiveUso} className='d-block productos__detail--svg' alt='' loading="lazy" />
              </div>
              <div className='col-12 productos__detail'>
                <img  src={imgTable} 
                      className='d-block w-100' 
                      alt={altText}
                      loading="lazy" />
              </div>
            </div>
          </div>
          <div className='col-12 col-sm-12 col-md-12 productos__vert mb-4 mt-1'>
            <p className='site_text productos__text--int mb-0'> 
              {textoDetail1}<br /><br />
              {textoDetail2}<br /><br />
              {textoDetail3}<br />
            </p>
          </div>
        </div>
        <div className='row'>
        
            <div className='col-12 col-sm-12 col-md-6 col-lg-4 mb-4' >
              <img src={imgThumb1} className='d-block w-100 p-0 m-0 ' alt={ imgThumb1Alt} loading="lazy" />
            </div>
            <div className='col-12 col-sm-12 col-md-6 col-lg-4 mb-4' >
              <img src={imgThumb2} className='d-block w-100 p-0 m-0 ' alt={ imgThumb2Alt} loading="lazy" />
            </div>
            <div className='col-12 col-sm-12 col-md-6 col-lg-4 mb-4' >
              <img src={imgThumb3} className='d-block w-100 p-0 m-0 ' alt={ imgThumb3Alt} loading="lazy" />
            </div>
        </div>       
      </Container>
    
  )
}

export default RacionadoresEmpaqueKive